import React, { useState } from "react";
import { api } from "@/lib/auth";
import { toast } from "sonner";
import { X } from "lucide-react";

export default function PaymentEditModal({ row, onClose, onDone }) {
  const [amount, setAmount] = useState(row.amount_paid ?? 0);
  const [status, setStatus] = useState(row.payment_status || "pending");
  const [notes, setNotes] = useState(row.notes || "");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/registrations/${row.type}/${row.id}/payment`, {
        amount: amount === "" ? 0 : Number(amount),
        payment_status: status, notes,
      });
      toast.success("Updated"); onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 grid place-items-center p-6" onClick={onClose}>
      <div className="card-surface p-6 max-w-md w-full" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-display text-2xl uppercase">Edit payment</h3>
          <button onClick={onClose}><X size={18}/></button>
        </div>
        <div className="text-zinc-400 text-xs mb-3">{row.full_name} · {row.program_name}</div>
        <div className="text-zinc-500 text-[11px] mb-4">Expected: ${Number(row.program_expected_amount ?? 0).toFixed(2)}</div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="eyebrow block mb-1">Amount paid ($)</label>
            <input type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} className="w-full bg-black border border-white/10 px-3 py-2 text-sm" data-testid="edit-payment-amount"/>
          </div>
          <div>
            <label className="eyebrow block mb-1">Status</label>
            <select value={status} onChange={e => setStatus(e.target.value)} className="w-full bg-black border border-white/10 px-3 py-2 text-sm" data-testid="edit-payment-status">
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
              <option value="manual">Manual</option>
              <option value="comp">Comp</option>
              <option value="refunded">Refunded</option>
            </select>
          </div>
          <div className="col-span-2">
            <label className="eyebrow block mb-1">Notes</label>
            <input value={notes} onChange={e => setNotes(e.target.value)} className="w-full bg-black border border-white/10 px-3 py-2 text-sm" data-testid="edit-payment-notes"/>
          </div>
        </div>
        <button onClick={submit} disabled={saving} className="btn-red w-full mt-4" data-testid="edit-payment-submit">{saving ? "Saving…" : "Save"}</button>
      </div>
    </div>
  );
}
